module.exports = __webpack_public_path__ + "static/media/5.7dd4ae99.gif";